import { useEffect, useState, createContext, useContext } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SiteSettingsContext = createContext({
  seo: {},
  content: {},
  codeInjection: {},
  loading: true
});

export const useSiteSettings = () => useContext(SiteSettingsContext);

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({ seo: {}, content: {}, codeInjection: {}, loading: true });

  useEffect(() => {
    axios.get(`${API}/site-settings/public`).then(res => {
      const { code_injection, seo, content } = res.data;
      setSettings({ seo, content, codeInjection: code_injection, loading: false });
      injectCode(code_injection);
    }).catch(() => {
      setSettings(prev => ({ ...prev, loading: false }));
    });
  }, []);

  return (
    <SiteSettingsContext.Provider value={settings}>
      {children}
    </SiteSettingsContext.Provider>
  );
};

function injectCode(codeInjection) {
  if (!codeInjection) return;

  // Header code → inject into <head>
  if (codeInjection.header_code) {
    const container = document.createElement('div');
    container.innerHTML = codeInjection.header_code;
    Array.from(container.childNodes).forEach(node => {
      if (node.tagName === 'SCRIPT') {
        const script = document.createElement('script');
        Array.from(node.attributes).forEach(attr => script.setAttribute(attr.name, attr.value));
        script.textContent = node.textContent;
        document.head.appendChild(script);
      } else {
        document.head.appendChild(node.cloneNode(true));
      }
    });
  }

  // Body code → inject after opening body
  if (codeInjection.body_code) {
    const container = document.createElement('div');
    container.innerHTML = codeInjection.body_code;
    Array.from(container.childNodes).forEach(node => {
      if (node.tagName === 'SCRIPT') {
        const script = document.createElement('script');
        Array.from(node.attributes).forEach(attr => script.setAttribute(attr.name, attr.value));
        script.textContent = node.textContent;
        document.body.insertBefore(script, document.body.firstChild);
      } else {
        document.body.insertBefore(node.cloneNode(true), document.body.firstChild);
      }
    });
  }

  // Footer code → inject before closing body
  if (codeInjection.footer_code) {
    const container = document.createElement('div');
    container.innerHTML = codeInjection.footer_code;
    Array.from(container.childNodes).forEach(node => {
      if (node.tagName === 'SCRIPT') {
        const script = document.createElement('script');
        Array.from(node.attributes).forEach(attr => script.setAttribute(attr.name, attr.value));
        script.textContent = node.textContent;
        document.body.appendChild(script);
      } else {
        document.body.appendChild(node.cloneNode(true));
      }
    });
  }
}
